import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render } from "react-dom"
import { BrowserRouter as Router } from "react-router-dom"
import { ErrorBoundary, Loading, ModalContainer } from "web/components"
import { TopicRecordList } from "web/components/Topic"
import { TLOContextProvider } from "web/contexts"
import { useDeal } from "web/hooks/data"
import { AppProviders, LibraryProviders } from "web/Providers"

export default class DealTopicRecordListController extends Controller {
  static values = {
    dealId: Number,
    topicName: String,
    basePath: String,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const CompanyTLOContextProvider = ({ children }) => {
      return (
        <TLOContextProvider subjectType="deal" data={useDeal(this.dealIdValue)}>
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <CompanyTLOContextProvider>
                <ErrorBoundary>
                  <TopicRecordList
                    subjectType="deal"
                    route={[{ key: this.topicNameValue }]}
                    rootUrl={this.basePathValue}
                  />
                </ErrorBoundary>
              </CompanyTLOContextProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
